<template>
  <div v-if="!isMantenance" id="direct-delivery" class="panel-body">
    <p class="text-size-20">セラー様が梱包、発送を行い倉庫へ納品する場合の納品プランを作成いただけます</p>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">基本情報入力</span>
      </div>
      <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <div class="box-delivery-name m-b-md">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="delivery-name"><strong>納品名</strong></div>
            </div>
            <div class="col-md-10 col-lg-7">
              <input type="text" :class="['form-control', deliveryName ? '' : 'bg-no-input']" v-model.trim="deliveryName">
              <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
              <div v-if="validateErrors.deliveryName.length" class="text-red"><b>{{ validateErrors.deliveryName[0]}}</b></div>
            </div>
          </div>
        </div>
        <div class="box-delivery-date m-b-md">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="delivery-date"><strong>納品予定日</strong></div>
            </div>
            <div class="col-md-10 col-lg-6">
              <date-picker
                v-model="deliveryDate"
                placeholder=""
                ref="datepickerStart"
                format="YYYY/MM/DD"
                :input-attr="{id: 'delivery-date'}"
                :lang="lang"
                :not-before="new Date()"
                :input-class="['mx-input', (deliveryDate) ? '' : 'bg-no-input']"
              ></date-picker>
              <div v-if="validateErrors.deliveryDate.length" class="text-red"><b>{{ validateErrors.deliveryDate[0]}}</b></div>
            </div>
          </div>
        </div>
        <div class="box-origin-info-default m-b-sm">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="m-b-sm"><strong>発送元情報</strong></div>
            </div>
            <div class="col-md-9 col-lg-10">
              <div v-if="deliveryInfo" class="delivery-info-default">
                <div>{{ deliveryInfo.name }}</div>
                <div>
                  {{ deliveryInfo.postalCode }} &nbsp;&nbsp;&nbsp; {{ deliveryInfo.address }}
                </div>
                <div>{{ deliveryInfo.phoneNo }}</div>
              </div>
              <a href="javascript:void(0)" class="text--underline" @click.prevent="openModalDeliveryInfo()">登録・変更はこちら</a>
              <div v-if="validateErrors.deliveryInfo.length" class="text-red"><b>{{ validateErrors.deliveryInfo[0]}}</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">商品情報入力</span>
      </div>
      <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'納品依頼'" @handleClickAdd="openModalDeliveryProductAdd()" @handleClickRegister="submitValidate()"/>
        <p class="">商品選択より、納品する商品を選択してください。</p>
        <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalDeliveryProductAdd()">商品選択</button>
        <button type="button" class="btn btn-warning check-maintenance" @click.prevent="openModalUpload()">CSVアップロード</button>
        <div v-if="selectedProducts.length" class="table-selected-products">
          <table>
            <thead>
              <tr>
                <th class="text-center w-150">納品する商品</th>
                <th style="min-width: 400px;"></th>
                <th class="text-right w-180">納品予定数</th>
                <th class="w-250">商品ラベル</th>
                <th class="w-220">商品ラベル貼付</th>
                <th class="w-220">有効期限</th>
                <th class="text-center">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                <td class="text-center">
                  <div class="box-selected-product-image w-40">
                    <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                  </div>
                  <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status_str)}`">{{ selectedProduct.status_str }}</div>
                </td>
                <td>
                  <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                  <div><b>ASIN：</b>{{ selectedProduct.asin }}</div>
                </td>
                <td class="td-vertical-top" align="right">
                  <input type="text" class="form-control expected-delivery-number text-right mr-t-30 w-100" :class="parseInt(selectedProduct.quantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)" @blur="updateStorageProducts()">
                  <div v-if="validateErrors.quantity[selectedProduct.asin] && validateErrors.quantity[selectedProduct.asin].length" class="text-red"><b>{{ validateErrors.quantity[selectedProduct.asin][0]}}</b></div>
                </td>
                <td colspan="3">
                  <div class="box-colspan gap-20">
                    <div class="w-230">
                      <fnsku-kbn-item
                        class="mr-t-30"
                        :key="`fnskuKbn-${selectedProduct.asin}`"
                        :product="selectedProduct"
                        :isChangeSku="true"
                        @update="updateStorageProducts()"
                      />
                      <div v-if="!validateErrors.fnsku[selectedProduct.asin] || selectedProduct.sku" class="text-gray">SKU：{{ selectedProduct.sku }}</div>
                      <div v-if="validateErrors.fnsku[selectedProduct.asin] && !selectedProduct.fnsku" class="text-red"><b>{{ validateErrors.fnsku[selectedProduct.asin]}}</b></div>
                    </div>
                    <div class="box-product-label-attach-kbn w-200">
                      <div class="h-30"></div>
                      <goods-label-attach-kbn-item
                        :product="selectedProduct"
                        @update="updateStorageProducts()"
                      />
                    </div>
                    <div class="box-due-date-manage w-200">
                      <due-date-management-item
                        :key="`due-date-manage-${selectedProduct.asin}`"
                        :product="selectedProduct"
                        @updateDueDateManageFlg="updateStorageProducts()"
                        @updateExpirationDate="updateStorageProducts()"
                        style="width: 100%;"
                      />
                      <div v-if="validateErrors.dueDateManagement[selectedProduct.asin] && validateErrors.dueDateManagement[selectedProduct.asin].length" class="text-red"><b>{{ validateErrors.dueDateManagement[selectedProduct.asin][0]}}</b></div>
                    </div>
                  </div>
                  <div :class="[getAvailabilityDate(selectedProduct) ? '' : 'availability-date-visibility']" class="m-t-xs availability-date text-right">
                    出荷可能期限日：{{ getAvailabilityDate(selectedProduct) }}までの注文に対して出荷することができます。
                  </div>
                </td>
                <td class="td-vertical-top text-center">
                  <div class="h-30"></div>
                  <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteSelectedProduct(selectedProduct)">削除</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center m-b-md m-t-md">
            <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="submitValidate">
              納品依頼
              <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div v-else class="empty-products text-center">
          <h3 class="m-b-xl text-center"><strong>商品選択より、納品する商品を選択してください。</strong></h3>
        </div>
      </div>
    </div>
    <delivery-info-modal
      v-if="openDeliveryInfoModal"
      ref="deliveryInfoModal"
      :type="'Across'"
      @close="closeModalDeliveryInfo"
      @openModalRegisterDeliveryInfo="openModalRegisterDeliveryInfo"
      @setDefaultInfoSuccess="setDeliverySellerInfo"
    />
    <register-delivery-info-modal
      v-if="openRegisterDeliveryInfoModal"
      ref="registerDeliveryInfoModal"
      :type="'Across'"
      @close="closeModalRegisterDeliveryInfo"
      @updatedDeliveryInfo="updatedDeliveryInfo"
      @registerDeliveryInfo="registerDeliveryInfo"
    />
    <delivery-product-add
      v-if="openDeliveryProductAddModal"
      ref="deliveryProductAddModal"
      :apiUrl="apiUrl"
      :deliverySelectedProducts="storageSelectedProducts"
      @onHandleSearch="onHandleSearch"
      @close="closeModalDeliveryProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert-get-latest-product
      v-if="showGetLatestProductModal"
      :message="getLatestProductNotiMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductModal"
      @confirm="confirmGetLatestProductModal"
    />
    <modal-alert
      v-if="showGetLatestProductCompletedModal"
      :message="getLatestProductCompletedMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductCompletedModal"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openConfirmModal"
      :message="confirmMessage"
      @confirm="handleRegister"
      @close="closeModalConfirmAdd"
    />
    <modal-confirm
      v-if="openConfirmOverwriteSkusModal"
      :message="needOverwriteSkusMessage"
      @confirm="handleRegister(true)"
      @close="closeModalConfirmOverwriteSkus"
    />
    <modal-alert
      v-if="openAddedModal"
      :message="addedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <upgrade-plan-modal
      v-if="isShowUpgradePlanModal"
      @close="closeUpgradePlanModal"
    />
    <upload-csv-modal
      v-if="isShowUploadModal"
      :header="uploadCsvHeader"
      :uploadUrl="'Warehouse/across/delivery/direct/product-available/upload'"
      :needProductId="true"
      :settingProductIdOptions="settingProductIdOptions"
      @handleDownloadTemplate="handleDownloadTemplate"
      @handleUploadSuccess="handleUploadSuccess"
      @close="closeUploadModal"
    />
    <modal-alert
      v-if="openUploadedModal"
      :message="uploadedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeUploadedModal"
    />
  </div>
  <maintenance-modal v-else :html="userInfo.acrossDeliveryStopExp" :hasBypassMaintenance="true"  @close="closeMaintenanceModal" @bypassMaintenance="bypassMaintenance" />
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import DeliveryInfoModal from '@/view/deliveryRequests/components/DeliveryInfoModal'
import RegisterDeliveryInfoModal from '@/view/deliveryRequests/components/RegisterDeliveryInfoModal'
import FnskuKbnItem from '@/view/warehouseAcross/components/FnskuKbnItem'
import DueDateManagementItem from '@/view/warehouseAcross/components/DueDateManagementItem'
import ShippingPackingItem from '@/view/deliveryRequests/components/ShippingPackingItem'
import GoodsLabelAttachKbnItem from '@/view/deliveryRequests/components/GoodsLabelAttachKbnItem'
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import ModalAlert from '@/components/ModalAlert'
import ModalAlertGetLatestProduct from '@/view/warehouseAcross/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import DeliveryProductAdd from '@/view/warehouseAcross/components/DeliveryProductAdd'
import FixedHeader from './components/FixedHeader'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'
import UploadCsvModal from '@/components/UploadCsvModal'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'
import MaintenanceModal from '@/view/warehouses/MaintenanceModal'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    ModalAlert,
    ModalAlertGetLatestProduct,
    ModalConfirm,
    DeliveryInfoModal,
    RegisterDeliveryInfoModal,
    FnskuKbnItem,
    DueDateManagementItem,
    ShippingPackingItem,
    GoodsLabelAttachKbnItem,
    DeliveryProductAdd,
    FixedHeader,
    UpgradePlanModal,
    UploadCsvModal,
    MaintenanceModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      apiUrl: '/Warehouse/across/delivery/direct/product-available',
      loader: null,
      isMantenance: true,
      openDeliveryInfoModal: false,
      openRegisterDeliveryInfoModal: false,
      showGetLatestProductModal: false,
      showGetLatestProductCompletedModal: false,
      openConfirmModal: false,
      openConfirmOverwriteSkusModal: false,
      openAddedModal: false,
      openDeliveryProductAddModal: false,
      openAlertValidateFailsModal: false,
      isShowUpgradePlanModal: false,
      isShowUploadModal: false,
      isShowFixedHeader: false,
      openUploadedModal: false,
      deliveryNo: null,
      deliveryName: null,
      deliveryDate: null,
      deliveryInfo: {},
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      validateErrors: {
        deliveryName: [],
        deliveryDate: [],
        deliveryInfo: [],
        quantity: {},
        fnsku: {},
        dueDateManagement: {}
      },
      storageSelectedProducts: [],
      getLatestProductNotiMessage: '商品情報を最新化する必要があります。<br> はじめに最新の商品情報を取得します。',
      getLatestProductCompletedMessage: '商品が最新状態に更新されました。',
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      confirmMessage: '納品情報を登録します。よろしいですか？',
      settingProductIdOptions: [
        {
          value: 'ASIN',
          text: 'ASIN'
        },
        {
          value: 'SKU',
          text: 'SKU'
        },
        {
          value: 'FNSKU',
          text: '商品ラベル(FNSKU)'
        }
      ],
      total: 0,
      invalids: [],
      duplicates: [],
      overwriteSkus: []
    }
  },
  created () {
    const query = this.$route.query
    if (query && query.deliveryNo) {
      this.getDirectDeliveryDetail(query.deliveryNo)
    } else {
      this.fetchDeliveryInfo()
      this.getSelectedProducts()
    }
  },
  computed: {
    ...mapGetters({
      deliveryInfoDefaultItem: 'getDeliveryInfoDefaultItem',
      userInfo: 'getUser'
    }),
    storageName () {
      return `${this.userInfo.sellerId}-DirectDeliverySelectedProducts`
    },
    selectedProducts () {
      return this.storageSelectedProducts
    },
    needOverwriteSkusMessage () {
      let html = '<p>ASINに対してSKUが変更されています。新しいSKUで上書きし、処理を続行しますか？</p>'

      if (this.overwriteSkus.length > 0) {
        html += '<ul>'
        this.overwriteSkus.forEach(overwriteSku => {
          html += `<li>
            <div><b>旧SKU:</b> ${overwriteSku.oldSku} → <b>新SKU:</b> ${overwriteSku.newSku}</div>
            <div class="text-gray"><b>商品名:</b> ${overwriteSku.itemName}</div>
            <div class="text-gray"><b>ASIN:</b> ${overwriteSku.asin} <b>FNSKU:</b> ${overwriteSku.fnsku}</div>
          </li>`
        })
      }
      html += '</ul>'
      return html
    },
    addedMessage () {
      return `
        納品情報を登録しました。 <br>
        納品管理番号： ${this.deliveryNo} <br> <br>
        <p>
          登録した納品情報に従って、ACROSS倉庫への発送を行ってください。
        </p>
        <br>
        <p>
          <span class="text-danger">※受取金額をご確認ください</span> <br>
          セルモンに出品している商品の場合、「商品管理 > 商品一覧」 画面にて <br>
          ACROSS倉庫商品の受取金額を確認・変更いただくことが可能です。
        </p>
      `
    },
    uploadCsvHeader () {
      return `<div class="flexbox">
        セラー様 → <img src="${this.$store.getters.getWareHouseIcons.salmonAcross}" class="w-20"> ACROSS倉庫へ納品する商品・数量をアップロードしてください
      </div>
      <span style="color: red; font-size: 14px;">「テンプレートをダウンロード」よりテンプレートをダウンロード・編集の上、ご登録ください。</span>
      `
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    uploadedMessage () {
      let html = `<p><b>${this.storageSelectedProducts.length}件/${this.total}件 商品の追加が成功しました</b></p>`

      if (this.invalids.length > 0) {
        html += `<div class="text-danger"><b>エラー${this.invalids.length}件 商品が存在しません</b></div>`
        this.invalids.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      if (this.duplicates.length > 0) {
        html += '<br>'
        html += `<div class="text-danger"><b>エラー${this.duplicates.length}件 商品が重複しています</b></div>`
        this.duplicates.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      return html
    }
  },
  methods: {
    bypassMaintenance () {
      $('#maintenance-modal').modal('hide')
      this.isMantenance = false
    },
    closeMaintenanceModal () {
      $('#maintenance-modal').modal('hide')
      this.$router.push('/warehouse-across/delivery/delivery-status-inquiry')
    },
    async getDirectDeliveryDetail (deliveryNo) {
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: deliveryNo
      }
      await WarehouseAcrossService.getDirectDeliveryDetail(params)
        .then((response) => {
          this.deliveryName = response.data.deliveryName
          this.deliveryInfo = response.data.deliveryInfo
          localStorage.removeItem(this.storageName)
          localStorage.setItem(this.storageName, JSON.stringify(response.data.deliveryGoods))
          this.storageSelectedProducts = response.data.deliveryGoods
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    openModalDeliveryInfo (fromAfterUpdate = false) {
      this.openDeliveryInfoModal = true
      if (!fromAfterUpdate) {
        let logParams = {
          name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_regis_or_update_shipping_info_btn,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }
    },
    closeModalDeliveryInfo () {
      $('#delivery-info-modal').modal('hide')
      this.openDeliveryInfoModal = false
    },
    openModalRegisterDeliveryInfo () {
      this.closeModalDeliveryInfo()
      this.openRegisterDeliveryInfoModal = true
    },
    closeModalRegisterDeliveryInfo () {
      $('#register-delivery-info-modal').modal('hide')
      this.openRegisterDeliveryInfoModal = false
    },
    closeGetLatestProductModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductModal = false
    },
    confirmGetLatestProductModal () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_update_inventory_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.closeGetLatestProductModal()
      this.getLatestProduct()
    },
    closeGetLatestProductCompletedModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductCompletedModal = false
    },
    closeModalDeliveryProductAdd () {
      $('#delivery-product-add-modal').modal('hide')
      this.openDeliveryProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmAdd () {
      if (this.isValidateFails) return
      this.openConfirmModal = true
    },
    closeModalConfirmAdd () {
      $('#confirm-alert').modal('hide')
      this.openConfirmModal = false
    },
    closeModalConfirmOverwriteSkus () {
      $('#confirm-alert').modal('hide')
      this.openConfirmOverwriteSkusModal = false
    },
    openModalAdded () {
      this.openAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAddedModal = false
      this.deliveryDate = null
      this.deliveryName = null
      this.deliveryNo = null
      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'delivery',
          subTab: 'delivery-status-inquiry'
        }
      })
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    },
    closeUploadModal () {
      this.isShowUploadModal = false
      $('#upload-csv-modal').modal('hide')
    },
    closeUploadedModal () {
      this.openUploadedModal = false
      $('#myModal').modal('hide')
    },
    updatedDeliveryInfo () {
      this.openModalDeliveryInfo(true)
    },
    registerDeliveryInfo () {
      this.setDeliverySellerInfo(this.deliveryInfoDefaultItem)
    },
    getSelectedProducts () {
      this.storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    onHandleSearch (keywordValue) {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_search_btn,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    deleteSelectedProduct (product) {
      this.storageSelectedProducts = this.storageSelectedProducts.filter(item => item.asin !== product.asin)
      localStorage.setItem(this.storageName, JSON.stringify(this.storageSelectedProducts))
    },
    handleSelectedProduct (product) {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_add_product_btn,
        properties: {
          asin: product.asin
        }
      }
      EventService.postTrackLog(logParams)

      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
      let selectedProducts = [...storageSelectedProducts, product]
      localStorage.setItem(this.storageName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    handleSelectedProducts (products) {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_add_products_btn,
        properties: {
          asins: products.map(p => p.asin)
        }
      }
      EventService.postTrackLog(logParams)

      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageName) || '[]')
      let selectedProducts = [...storageSelectedProducts, ...products]
      localStorage.setItem(this.storageName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    updateStorageProducts () {
      let selectedProducts = this.storageSelectedProducts
      localStorage.removeItem(this.storageName)
      this.storageSelectedProducts = []
      this.handleSelectedProducts(selectedProducts)
    },
    getAvailabilityDate (product) {
      let availabilityDate = ''
      let expirationDate = product.expirationDate
      if (!expirationDate) {
        return availabilityDate
      }
      let minusDate = product.settingShippingNgPeriodValue

      if (product.hasYamatoOffer && product.yamatoShippingNgPeriod) {
        minusDate = product.yamatoShippingNgPeriod
      }

      let newDate = new Date(expirationDate)
      newDate.setDate(newDate.getDate() - minusDate)
      availabilityDate = moment(newDate).format('YYYY/MM/DD')

      return availabilityDate
    },
    checkLatestProductDate () {
      if (this.userInfo.getLatestProductsDate === null) {
        return true
      }
      const minusUpdateLatest = 120
      let getLatestProductsDate = new Date(this.userInfo.getLatestProductsDate)
      getLatestProductsDate.setTime(getLatestProductsDate.getTime() + minusUpdateLatest * 60 * 1000)
      let now = new Date()
      return now.getTime() >= getLatestProductsDate.getTime()
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    openModalDeliveryProductAdd () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.openDeliveryProductAddModal = true
      }
    },
    openModalUpload () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_upload_by_csv,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.isBasicPlan) {
        this.isShowUpgradePlanModal = true
        return
      }

      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.isShowUploadModal = true
      }
    },
    async getLatestProduct () {
      this.loader = this.$loading.show()
      await ProductService.getLatestProducts()
        .then((response) => {
          this.clearStorage()
          this.getSellerInfo()
          this.showGetLatestProductCompletedModal = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
    },
    clearStorage () {
      localStorage.removeItem(this.storageName)
      this.storageSelectedProducts = []
    },
    async submitValidate () {
      this.validateInput()
    },
    validateInput () {
      let required = '※必ず入力してください'
      let number = '※半角数値で入力してください'
      this.isValidateFails = false
      if (!this.deliveryName || !this.deliveryName.trim()) {
        this.validateErrors.deliveryName.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.deliveryName = []
      }
      if (!this.deliveryDate) {
        this.validateErrors.deliveryDate.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.deliveryDate = []
      }
      if (!this.deliveryInfo || !Object.keys(this.deliveryInfo).length) {
        this.validateErrors.deliveryInfo.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.deliveryInfo = []
      }

      this.storageSelectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let asin = product.asin
        let isQuantityNaN = (product.quantity !== '' && product.quantity !== null) ? isNaN(product.quantity) : false
        this.validateErrors.quantity[asin] = []
        this.validateErrors.dueDateManagement[asin] = []
        if (isQuantityNaN) {
          this.validateErrors.quantity[asin][0] = number
          this.isValidateFails = true
        } else if (!isQuantityNaN && !quantity) {
          this.validateErrors.quantity[asin][0] = required
          this.isValidateFails = true
        } else {
          delete this.validateErrors.quantity[asin]
        }

        if (!product.expirationDate && product.dueDateManageFlg) {
          this.validateErrors.dueDateManagement[asin][0] = required
          this.isValidateFails = true
        } else {
          delete this.validateErrors.dueDateManagement[asin]
        }

        if (!product.fnsku) {
          this.validateErrors.fnsku[asin] = required
          this.isValidateFails = true
        } else {
          delete this.validateErrors.fnsku[asin]
        }
      })

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmAdd()
      }
    },
    handleRegister (acceptOverwriteSkus = false) {
      if (this.isValidateFails) return

      this.closeModalConfirmAdd()
      if (this.openConfirmOverwriteSkusModal) {
        this.closeModalConfirmOverwriteSkus()
      }
      this.loader = this.$loading.show()

      let params = {
        deliveryGoods: this.storageSelectedProducts,
        deliveryName: this.deliveryName,
        deliveryDate: this.formatDate(this.deliveryDate),
        deliveryInfo: this.deliveryInfo
      }
      if (acceptOverwriteSkus) {
        params.acceptOverwriteSkus = acceptOverwriteSkus
      }
      WarehouseAcrossService.registerAcrossDelivery(params)
        .then((response) => {
          if (response.data && response.data.overwriteSkus && response.data.overwriteSkus.length > 0) {
            this.overwriteSkus = response.data.overwriteSkus
            this.$nextTick(() => {
              this.openConfirmOverwriteSkusModal = true
            })

            let logParams = {
              name: eventCode.warehouse_across.delivery_tab.direct_delivery.show_duplicate_skus,
              properties: this.overwriteSkus
            }
            EventService.postTrackLog(logParams)

            return false
          }
          this.deliveryNo = response.data.deliveryNo
          this.openModalAdded()
          this.clearStorage()
          const code = acceptOverwriteSkus ? eventCode.warehouse_across.delivery_tab.direct_delivery.click_request_delivery_with_overwrite_skus_btn : eventCode.warehouse_across.delivery_tab.direct_delivery.click_request_delivery_btn
          let logParams = {
            name: code,
            properties: {
              deliveryNo: this.deliveryNo
            }
          }
          EventService.postTrackLog(logParams)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    fetchDeliveryInfo () {
      this.loader = this.$loading.show()
      DeliveryInfoSellerService.fetchDeliveryInfo()
        .then((response) => {
          this.$store.commit('setDeliveryInfoItems', response.data)
          if (Object.keys(this.deliveryInfo).length === 0 && response.data.length > 0) {
            const deliveryInfo = response.data.find(item => { return item.defFlg === '1' })
            this.setDeliverySellerInfo(deliveryInfo)
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    setDeliverySellerInfo (data) {
      if (data) {
        this.deliveryInfo = {
          name: data.name,
          address: data.address,
          phoneNo: data.phoneNo,
          postalCode: data.postalCode
        }
      }
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      if (fixedHeader) {
        const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
        this.isShowFixedHeader = window.scrollY >= initialOffset
      }
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    },
    handleDownloadTemplate () {
      let logParams = {
        name: eventCode.warehouse_across.delivery_tab.direct_delivery.click_download_template,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      WarehouseAcrossService.downloadDirectDeliveryProductsTemplate({}, '納品テンプレート.csv')
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    handleUploadSuccess (response) {
      this.clearStorage()
      const data = response.records.data
      this.total = data.total
      this.invalids = data.invalids
      this.duplicates = data.duplicates
      this.handleSelectedProducts(data.products)
      this.closeUploadModal()
      this.openUploadedModal = true
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.delivery_tab.direct_delivery.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    window.addEventListener('scroll', this.handleScroll)
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#direct-delivery {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.custom-btn-delivery {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
</style>
<style>
#direct-delivery .bg-no-input {
  background-color: #fdefef !important;
}
#direct-delivery .row {
  margin-left: -15px;
  margin-right: -15px;
}
#direct-delivery .mx-datepicker {
  width: 190px;
}
.mr-5 {
  margin: 5px;
}
.w-230 {
  width: 230px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/DirectDelivery.vue